import {create} from 'zustand'
import { UserType } from 'src/types/UserType';

interface userInfoState extends UserType{
    setField: (field: keyof UserType, value: string) => void 
    reset:()=>void
}

export const useUserInfoStore = create<userInfoState>((set)=>({
    user_id: '',
    phone : '',
    uid: 0,
    user_name: '',
    user_type: '',
    email: '',
    army_number: '',
    user_area:{},
    excluded_highschool:[],
    excluded_university:[],
    team_name:'',
    setField: (field,value)=>set((state)=>({...state,[field]:value})),
    reset: () =>
        set(() => ({
            user_id: '',
            phone : '',
            uid: 0,
            user_name: '',
            user_type: '',
            email: '',
            army_number: '',
            user_area:{},
            excluded_highschool:[],
            excluded_university:[],
            team_name:''
        })),
}))

interface TempsUserStoreState {
    userName : string;
    setField: (field: keyof TempsUserStoreState, value: string) => void 
    reset : ()=>void
}

const defaultValue = {
    userName : ""
}

export const TempUserStore = create<TempsUserStoreState>((set)=>({
    ...defaultValue,
    setField: (field,value)=>set((state)=>({...state,[field]:value})),
    reset:()=>
        set(()=>({
            ...defaultValue
        }))
}))